export const PRICE = '23 $'

export const BRAND = 'Barber Instructor Ready™'

/** Carrousel — pages réelles du Volume 2, dans cet ordre exact. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5tRgMr6kHXTmRUD4hpuuTn/01_pagina_17.png',
    caption: 'Taper, Drop Fade et Burst Fade — Page 17',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gve9VJzwuUpdRrmTPrZZSy/02_pagina_15.png',
    caption: 'Dégradé à blanc — Skin Fade — Page 15',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/v7GKbDXsafPdkUQexixyFk/03_pagina_7.png',
    caption: 'Repères de coupe — Le vocabulaire — Page 7',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m29LtmbKnyfjtKzw2uo3yf/04_pagina_28.png',
    caption: 'Contours de barbe — La ligne propre — Page 28',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gZx7B9XnFit9XKDKtbV5Bd/05_pagina_46.png',
    caption: 'Adapter la technique à la texture — Page 46',
  },
]

/** Section problème — quatre difficultés. */
export const painPoints = [
  {
    title: 'Trop de temps consacré à la préparation',
    text: 'Chaque nouveau cours demande de longues heures d’organisation.',
  },
  {
    title: 'Des supports dispersés',
    text: 'Vos ressources sont réparties entre différents documents et fichiers.',
  },
  {
    title: 'Des techniques difficiles à expliquer',
    text: 'Vous devez répéter les mêmes démonstrations pour chaque groupe.',
  },
  {
    title: 'Des évaluations à créer',
    text: 'Il faut encore préparer les exercices, les critères et le suivi des élèves.',
  },
]

/** Section solution — quatre bénéfices. */
export const solutionBenefits = [
  'Gagnez du temps dans la préparation des cours.',
  'Expliquez les techniques avec des supports structurés.',
  'Proposez des exercices pratiques à vos élèves.',
  'Suivez leur progression avec des outils d’évaluation.',
]

/** Les six volumes. Couleurs d’accent identiques aux couvertures du mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Les Fondamentaux de l’Enseignement en Barbering et les Essentiels Professionnels',
    description: 'Les bases pédagogiques et professionnelles pour structurer votre approche de l’enseignement.',
    accent: '#EEF4FA',
  },
  {
    number: 2,
    title: 'La Bibliothèque Complète des Techniques de Coupe Masculine et de Barbering',
    description:
      'Des techniques de coupe, des dégradés, des styles classiques et modernes, ainsi que des démonstrations détaillées.',
    accent: '#D8EAF7',
  },
  {
    number: 3,
    title: 'Le Système Pédagogique Prêt à Enseigner',
    description: 'Des structures de cours, des guides pédagogiques et des ressources pour organiser vos leçons.',
    accent: '#DCECDF',
  },
  {
    number: 4,
    title: 'Le Cahier de Pratique et de Développement des Compétences',
    description: 'Des exercices, des fiches de travail et des activités pour accompagner la pratique des élèves.',
    accent: '#FFF0C2',
  },
  {
    number: 5,
    title: 'Le Kit d’Évaluation et de Certification',
    description: 'Des outils d’évaluation, des grilles de notation et des ressources pour suivre les progrès.',
    accent: '#F9D5C8',
  },
  {
    number: 6,
    title: 'Le Guide de Gestion de Classe et de Formation',
    description:
      'Des ressources pour organiser les cours, gérer les procédures et structurer le fonctionnement des formations.',
    accent: '#E8DDF5',
  },
]

export const volumeFlow = ['Fondamentaux', 'Techniques', 'Leçons', 'Pratique', 'Évaluation', 'Gestion de classe']

/** Ressources visuelles incluses. */
export const visualResources = [
  'Cartes des hauteurs de dégradé',
  'Silhouettes des coupes classiques',
  'Guides taper, drop et burst fade',
  'Repères de sabots de tondeuse',
  'Contours et design de barbe',
  'Plans de séparation des sections',
  'Vocabulaire technique illustré',
  'Erreurs fréquentes des élèves',
  'Stratégies de correction',
  'Démonstrations étape par étape',
]

/** Les cinq bonus. */
export const bonuses = [
  {
    number: 'Bonus n° 1',
    title: 'La Bibliothèque Visuelle d’Enseignement du Formateur™',
    description:
      'Schémas, cartes de la tête et visuels techniques pour aider les élèves à voir exactement ce que vous expliquez.',
    badge: 'Visuels prêts',
    accent: '#D8EAF7',
  },
  {
    number: 'Bonus n° 2',
    title: 'Le Kit de Démarrage Rapide en Classe™',
    description: 'Tout pour lancer une classe rapidement : ressources du premier jour, routines et listes de contrôle.',
    badge: 'Classe prête',
    accent: '#DCECDF',
  },
  {
    number: 'Bonus n° 3',
    title: 'Le Guide de Dépannage et de Correction des Compétences™',
    description:
      'Les erreurs techniques les plus fréquentes, leurs causes et comment les corriger avant qu’elles ne deviennent des habitudes.',
    badge: 'Corrections prêtes',
    accent: '#FFF0C2',
  },
  {
    number: 'Bonus n° 4',
    title: 'La Boîte à Outils Interactive pour la Classe™',
    description: 'Activités, sujets de discussion et jeux rapides pour garder les élèves impliqués et participatifs.',
    badge: 'Activités prêtes',
    accent: '#F9D5C8',
  },
  {
    number: 'Bonus n° 5',
    title: 'Le Kit Carrière et Portfolio de l’Élève™',
    description:
      'Modèles de portfolio et ressources de préparation professionnelle pour aider les élèves à présenter leur travail.',
    badge: 'Carrière préparée',
    accent: '#E8DDF5',
  },
]

/** Avant / après. */
export const withoutSystem = [
  'Chercher des supports pédagogiques.',
  'Préparer chaque exercice à partir de zéro.',
  'Réorganiser constamment ses notes.',
  'Improviser certaines explications.',
  'Créer ses propres grilles d’évaluation.',
]

export const withSystem = [
  'Consulter des ressources déjà structurées.',
  'S’appuyer sur des exercices pratiques.',
  'Organiser les leçons plus facilement.',
  'Utiliser des supports pour expliquer les techniques.',
  'Disposer d’outils pour évaluer les compétences.',
]

/** Pour qui. */
export const audience = [
  'Formateurs en barbering',
  'Instructeurs en coiffure masculine',
  'Enseignants en barbering',
  'Responsables d’académies',
]

/** Contenu de l’offre. */
export const offerIncludes = [
  '6 volumes pédagogiques',
  '5 bonus complémentaires',
  'Techniques et démonstrations',
  'Exercices et supports de cours',
  'Outils d’évaluation',
  'Accès numérique immédiat',
]

/** Ce qu’une seule ressource vous fait gagner. */
export const onePartItems = [
  'Un schéma de dégradé que vous n’avez pas à dessiner.',
  'Une leçon que vous n’avez pas à planifier.',
  'Une fiche de travail que vous n’avez pas à créer.',
  'Une évaluation que vous n’avez pas à préparer.',
]

export const faqs = [
  {
    question: 'À qui s’adresse Barber Instructor Ready ?',
    answer:
      'Aux formateurs en barbering, instructeurs en coiffure masculine et responsables d’académies souhaitant structurer leurs ressources pédagogiques.',
  },
  {
    question: 'Le contenu est-il entièrement en français ?',
    answer: 'Oui, cette édition est conçue en français.',
  },
  {
    question: 'S’agit-il d’un produit physique ?',
    answer: 'Non. Il s’agit de ressources numériques au format PDF. Aucun livre physique ne sera expédié.',
  },
  {
    question: 'Comment vais-je recevoir les ressources ?',
    answer:
      'Les modalités d’accès et de téléchargement seront communiquées après le paiement, selon le système de livraison configuré.',
  },
  {
    question: 'Puis-je utiliser ces ressources pour préparer mes cours ?',
    answer:
      'Oui. Elles sont conçues pour aider les formateurs à organiser leurs leçons et accompagner l’apprentissage des élèves.',
  },
  {
    question: 'Est-ce un abonnement ?',
    answer: 'Non. Le prix affiché correspond à un paiement unique.',
  },
  {
    question: 'Le paiement est-il sécurisé ?',
    answer: 'Oui. Le paiement est sécurisé et crypté, et il est traité automatiquement dans votre devise locale.',
  },
]
